// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__dl0PP","textWrapper":"footer_textWrapper__PSolf","textWrapperNew":"footer_textWrapperNew__-z8oD","iconStyles":"footer_iconStyles__JwIZW"};